import { CommonModule } from '@angular/common';
import { Component, signal, ViewEncapsulation, OnInit, OnDestroy, Input, inject, computed, InputSignal, input, Output, EventEmitter, effect, untracked } from '@angular/core';
import { MatSliderModule } from '@angular/material/slider';
import { ExpandIconComponent } from './icons/expand.component';
import { BackwardIconComponent } from './icons/backward.component';
import { ForwardIconComponent } from './icons/forward.component';
import { PlayIconComponent } from './icons/play.component';
import { VolumeOnIconComponent } from './icons/volume-on.component';
import { VolumeOffIconComponent } from './icons/volume-off.component';
import { PauseIconComponent } from './icons/pause.component';
import { CloseIconComponent } from './icons/close.component';
import { VideoPlayerService } from './audio-player.service';
import { ModalController } from '@ionic/angular';
import { AudioModalComponent } from './modal/audio-modal.component';
import { NoCoverIconComponent } from './icons/no-cover.component';

@Component({
  selector: 'audio-player',
  standalone: true,
  imports: [
    CommonModule,
    MatSliderModule,
    ExpandIconComponent,
    BackwardIconComponent,
    ForwardIconComponent,
    PlayIconComponent,
    VolumeOnIconComponent,
    VolumeOffIconComponent,
    PauseIconComponent,
    CloseIconComponent,
    NoCoverIconComponent
  ],
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class AudioPlayerComponent implements OnInit, OnDestroy {
    @Output() private closeEmitter: EventEmitter<any> = new EventEmitter<any>();
    private audioPlayerService = inject(VideoPlayerService);
    private modalController = inject(ModalController);

    public src: InputSignal<string> = input<string>(null);
    public cover: InputSignal<string> = input<string>(null);
    public title: InputSignal<string> = input<string>(null);
    public address: InputSignal<string> = input<string>(null);

    public isPlaying = computed(() => this.audioPlayerService.isPlaying());
    public isMuted = computed(() => this.audioPlayerService.isMuted());
    public currentTime = computed(() => this.audioPlayerService.currentTime());
    public duration = computed(() => this.audioPlayerService.duration());
    public durationString = computed(() => this.audioPlayerService.durationString());
    public playingDurationString = computed(() => this.audioPlayerService.playingDurationString());
    public isAudio = computed(() => this.audioPlayerService.audio())
    public isHidden = signal(false);

    changeSrc = effect(() => {
        const src = this.src();
        untracked(async () => {
            this.audioPlayerService.loadTrack(src);
            await this.audioPlayerService.playAudio();
        })
    }, { allowSignalWrites: true })

    private audioModal;

    ngOnInit(): void {
        // this.audioPlayerService.loadTrack(this.src())
    }

    handleBackward() {
        this.audioPlayerService.handleBackward();
    }

    handleForward() {
        this.audioPlayerService.handleForward();
    }

    handlePlayPause() {
        this.audioPlayerService.handlePlayPause();
    }

    toggleMute() {
        this.audioPlayerService.toggleMute();
    }

    changeValue(value: number){
        this.audioPlayerService.changeValue(value);
    }

    async openAudioModal() {
        this.isHidden.set(true);
        this.audioModal = await this.modalController.create({
            component: AudioModalComponent,
            cssClass: ['audio-modal', 'ion-disable-focus-trap'],
        });
        await this.audioModal.present();
        await this.audioModal.onDidDismiss();
        this.isHidden.set(false);
    }

    closeAudioPlayer(){
        this.closeEmitter.emit(true);
    }

    ngOnDestroy(): void {
        this.audioPlayerService.teardownAudio();
    }

}